import React from 'react';



function About() {
 

  return (
    <section className="about-section2 section-padding fix section-bg2">
      <div className="shape">
        <img src="./assets/img/shape/plane-2.png" alt="Plane shape" />
      </div>
      <div className="container">
        <div className="about-wrapper2">
          <div className="section-title-area">
            <div className="section-title mb-0">
              <span className="sub-title style-2 wow fadeInUp">
                We Care About Your Happiness
              </span>
              <h2 className="wow fadeInUp" data-wow-delay=".3s">
                We Are Your Gateway <br /> to Adventure
              </h2>
            </div>
            <div className="number wow fadeInUp">
              <h1>19+</h1>
              <h4>
                Years of <br /> Pro Experiences
              </h4>
            </div>
          </div>
          <div className="row g-4 mt-3">
            <div className="col-xl-5 col-lg-6">
              <div className="thumb">
                <img
                  src="./assets/img/about/about-5.jpg"
                  alt="About"
                  className="wow img-custom-anim-left"
                />
              </div>
            </div>
            <div className="col-xl-7 col-lg-6">
              <div className="content-wrapper">
                <div className="content">
                  <h3 className="wow fadeInUp" data-wow-delay=".3s">
                    SINCE 2006
                  </h3>
                  <p className="wow fadeInUp" data-wow-delay=".5s">
                    At Express Travel, we believe in the transformative <br />
                    power of travel. As avid explorers ourselves, we <br />{' '}
                    understand the desire to uncover experiences, <br /> forge
                    meaningful.
                  </p>
                  <div
                    className="about-button wow fadeInUp"
                    data-wow-delay=".7s"
                  >
                    <a href="about.html" className="theme-btn style-2">
                      More About Us
                      <img
                        src="./assets/img/icon/white-arrow.svg"
                        alt="Arrow"
                      />
                    </a>
                  </div>
                </div>
                <div className="thumb">
                  <img
                    src="./assets/img/about/about-6.jpg"
                    alt="About"
                    className="wow img-custom-anim-right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="brand-wrapper">
          <h4 className="brand-title wow fadeInUp" data-wow-delay=".3s">
            Our Trusted Partners
          </h4>
          <div class="swiper brand-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="brand-image">
                <img src="./assets/img/brand/1.png" alt="brand"/>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="brand-image">
                <img src="./assets/img/brand/1.png" alt="brand"/>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="brand-image">
                <img src="./assets/img/brand/1.png" alt="brand"/>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="brand-image">
                <img src="./assets/img/brand/1.png" alt="brand"/>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="brand-image">
                <img src="./assets/img/brand/1.png" alt="brand"/>
              </div>
            </div>
          </div>
        </div>
          <h4 className="brand-title2 wow fadeInUp" data-wow-delay=".3s">
            We have over <span>2,000</span> partners
          </h4>
        </div>
      </div>
    </section>
  );
}

export default About;